<div class="SLV2-excrsprgrs-poparea">
    <div class="SLV2-excrsprgrs-hdr">
        <span>Exercise</span>
        <button class="SLV2-popup-close-btn" mat-dialog-close>
            <img src="selflearnv2-ui/assets/img/self-learn-v2/close-white-icon.svg" />
        </button>
    </div>

    <!-- design 1 start -->
    <ng-container *ngIf="!exerciseData.isInprogress && !exerciseData.isSubmitted">
        <ng-container *ngTemplateOutlet="SLV2Attmpcunt"></ng-container>

        <div class="SLV2-progress-info-box">
            <div class="SLV2-progress-icon-holdr">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/brain-animated.gif" />
            </div>
            <div class="SLV2-progress-info-cntarea">
                <h3 class="SLV2-progress-greeting-hdng">Hey, Welcome to the exercise!</h3>
                <p class="SLV2-progress-text">Score 80% or higher to clear this exercise</p>
                <div class="SLV2-progress-actn-area">
                    <button class="SLV2-progress-solid-btn" (click)="navigateToExerciseQuestions()">Let’s Begin</button>
                    <!-- <button class="SLV2-progress-text-btn">View solutions</button> -->
                </div>
            </div>
        </div>
    </ng-container>
    <!-- design 1 closed -->
    <ng-container *ngIf="exerciseData.isSubmitted && this.accuracy.accuracy>=80">
        <div class="SLV2-progress-info-box white">
            <ng-container *ngTemplateOutlet="SLV2Accuracycunt"></ng-container>

            <div class="SLV2-progress-icon-holdr sm">
                <img src="selflearnv2-ui/assets/img/animation-champion-icon.gif" />
            </div>
            <div class="SLV2-progress-info-cntarea">
                <h3 class="SLV2-progress-greeting-hdng">Congrats!</h3>
                <p class="SLV2-progress-text">You have already cleared this exercise.</p>
                <p class="SLV2-progress-text">We recommend you to practice next topic.</p>
                <div class="SLV2-progress-actn-area">
                    <button class="SLV2-progress-solid-btn" (click)="goToNextTopic()">{{isLastTopic ? 'Continue Learning' : 'Go To Next Topic'}}</button>
                    <button class="SLV2-progress-text-btn" (click)="viewSolutionForExercise()">View solutions</button>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- design 2 start -->
    <ng-container *ngIf="exerciseData.isInprogress">
        <ng-container *ngTemplateOutlet="SLV2Attmpcunt"></ng-container>

        <div class="SLV2-progress-info-box">
            <!-- <ng-container *ngTemplateOutlet="SLV2Accuracycunt"></ng-container> -->

            <div class="SLV2-progress-icon-holdr">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/brain-animated.gif" />
            </div>
            <div class="SLV2-progress-info-cntarea">
                <h3 class="SLV2-progress-greeting-hdng">Hey, Welcome to the exercise!</h3>
                <p class="SLV2-progress-text">You left in the middle last time.<br>
                    Score at least 80% to clear this exercise.</p>
                <p class="SLV2-progress-text">Resume now to improve your score</p>
                <div class="SLV2-progress-actn-area">
                    <button class="SLV2-progress-solid-btn" (click)="navigateToExerciseQuestions()">Resume</button>
                    <!-- <button class="SLV2-progress-text-btn">View solutions</button> -->
                </div>
            </div>
        </div>
    </ng-container>
    <!-- design 2 closed -->

    <!-- design 3 start -->
    <ng-container *ngIf="exerciseData.isSubmitted && this.accuracy.accuracy<80">
        <ng-container *ngTemplateOutlet="SLV2Attmpcunt"></ng-container>
    
        <div class="SLV2-progress-info-box">
            <ng-container *ngTemplateOutlet="SLV2Accuracycunt"></ng-container>
    
            <div class="SLV2-progress-icon-holdr">
                <img src="selflearnv2-ui/assets/img/self-learn-v2/brain-animated.gif" />
            </div>
            <div class="SLV2-progress-info-cntarea">
                <h3 class="SLV2-progress-greeting-hdng">Yay! almost there</h3>
                <p class="SLV2-progress-text">Score at least 80% to clear this execrise.</p>
                <p class="SLV2-progress-text">Don’t worry, together we will get there!</p>
                <div class="SLV2-progress-actn-area">
                    <button class="SLV2-progress-solid-btn"(click)="reattemptNow()">Re-attempt</button>
                    <!-- <button class="SLV2-progress-text-btn">View solutions</button> -->
                </div>
            </div>
        </div>
    </ng-container>
    <!-- design 3 closed -->


</div>





<ng-template #SLV2Attmpcunt>
    <div class="SLV2-attmpcunt-section">
        <div class="SLV2-attmp-info"><img class="icon"
                src="selflearnv2-ui/assets/img/self-learn-v2/users-white-group.svg" /><span>{{noOfViews}}
                attempts</span></div>
        <div class="SLV2-attmp-info"><img class="icon white"
                src="selflearnv2-ui/assets/img/self-learn-v2/document-icon.svg" /><span>{{questionsData.length}}
                Que’s</span></div>
    </div>
</ng-template>

<ng-template #SLV2Accuracycunt>
    <div class="SLV2-accuracy-box">
        <div class="SLV2-acrcy-col">
            <h4 class="SLV2-accuracy-title">Accuracy <img src="selflearnv2-ui/assets/img/self-learn-v2/info-icon.svg" />
            </h4>
            <h3 class="SLV2-accuracy-number">{{ this.accuracy.accuracy | number: '1.0-0'}}%</h3>
        </div>
        <div class="SLV2-acrcy-col">
            <h4 class="SLV2-accuracy-title">Attempts</h4>
            <h3 class="SLV2-accuracy-number">{{  this.accuracy.attemptnumber < 10 ? '0'+this.accuracy.attemptnumber  : this.accuracy.attemptnumber }}</h3>
        </div>
    </div>
</ng-template>